import { useState } from 'react'
import AgencyMark from '../marks/AgencyMark'
import MissionPicker from './MissionPicker'
import Cased from '../ui/Cased'
import { america, findMission, parentOf } from '@/content/missions'
import { usePrefs } from '@/state/prefs'

/**
 * The active mission, with its mark and name, and a button that opens the
 * mission picker: searchable, and grouped by department.
 */
export default function MissionSwitcher() {
  const { prefs } = usePrefs()
  const [open, setOpen] = useState(false)
  const mission = findMission(prefs.mission) ?? america
  const parent = parentOf(mission)
  return (
    <div className="mds-card mds-card--outline mission-switcher">
      <AgencyMark mission={mission} variant={prefs.mark} className="mission-switcher__mark" />
      <div className="mission-switcher__text">
        <p className="mission-switcher__name">{mission.name}</p>
        {parent && <p className="mds-muted">{parent.name}</p>}
      </div>
      <button type="button" className="mds-button mds-button--secondary" onClick={() => setOpen(true)} aria-haspopup="dialog">
        <Cased>Choose another mission</Cased>
      </button>
      <MissionPicker open={open} onClose={() => setOpen(false)} />
    </div>
  )
}
